import pluralize from 'pluralize';
import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';
import ClientApprovalDetails from './ClientApprovalDetails';

export default function BulkDelete({ ids, project, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projects(project.id)
          .clientApprovals()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={ClientApprovalDetails}>
      {`Are you sure you want to delete ${ids.length} ${pluralize('client approval', ids.length)}? This action cannot be undone.`}
    </BulkActionModal>
  );
}
